import { connect } from "react-redux";
import ResetPassword from "./ResetPassword";

import { reset, resetRedirectReset } from "../../ResetPassword/resetPasswordActions";

const mapStateToProps = (state) => ({
  resetPassword: state.resetPassword,
});

const mapDispatchToProps = {
  reset,
  resetRedirectReset,
};

export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword);
